<template>
  <div>
    <TopBar />
    <ContentEditor />
  </div>
</template>

<script setup>
import ContentEditor from './ContentEditor.vue';
import TopBar from './TopBar.vue';

</script>

<style scoped>

</style>
